import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Navlist from './Navlist';
import '../styles/Hamburger.css';

export default function TemporaryDrawer() {
    const [check, setCheck] = React.useState(false);

    const toggleDrawer = () => {
        setCheck(prev => !prev);
    }

    return (
        <div id="menu-icon">
            <Button onClick={toggleDrawer}>
                <div className='bars'>
                    <div id="bar1" className="bar"></div>
                    <div id="bar2" className="bar"></div>
                    <div id="bar3" className="bar"></div>
                </div>
            </Button>
            <Drawer
                anchor='right'
                open={check}
                onClose={toggleDrawer}
            >
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer}
                    onKeyDown={toggleDrawer}
                >
                    <Navlist />
                </Box>
            </Drawer>
        </div>
    );
}
